/* eslint-disable no-undef */
import axios from 'utils/axios';
import jwtDecode from 'jwt-decode';

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      },
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  loginWithEmailAndPassword = (email, password) =>
    new Promise((resolve, reject) => {
      axios
        .post('/admin/auth/login', { email, password })
        .then((response) => {
          if (response.data.data && response.data.data.token) {
            this.setSession(response.data.data.token);

            resolve(response.data.data);
          } else if (response.data.token) {
            this.setSession(response.data.token);
            resolve(response.data);
          } else {
            reject(response.data.error || 'Invalid credentials');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  loginInWithToken = () =>
    new Promise((resolve, reject) => {
      axios
        .get('/admin/account/me')
        .then((response) => {
          if (response.data && response.data.data) {
            resolve(response.data.data);
          } else if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error || 'Unable to fetch user profile');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  logout = async () => {
    try {
      if (this.isAuthenticated()) {
        await axios.post('/admin/auth/logout');
      }
    } finally {
      this.setSession(null);
    }
  };

  setSession = (accessToken) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
    } else {
      localStorage.removeItem('accessToken');
    }
  };

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    try {
      const decoded = jwtDecode(accessToken);
      const currentTime = Date.now() / 1000;

      if (decoded && decoded.exp) {
        return decoded.exp > currentTime;
      }

      return true;
    } catch (error) {
      return true;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
